
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const LayersIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M50.1069 12.7052C48.8596 11.7649 47.1404 11.7649 45.8931 12.7052L13.3931 37.2052C12.5158 37.8665 12 38.9014 12 40C12 41.0986 12.5158 42.1335 13.3931 42.7948L45.8931 67.2948C47.1404 68.2351 48.8596 68.2351 50.1069 67.2948L82.6069 42.7948C83.4842 42.1335 84 41.0986 84 40C84 38.9014 83.4842 37.8665 82.6069 37.2052L50.1069 12.7052ZM48 60.1169L21.3143 40L48 19.8831L74.6857 40L48 60.1169Z" fill="#161617"/>
<path d="M17.6071 53.2051C16.0635 52.0415 13.869 52.3495 12.7054 53.8931C11.5418 55.4366 11.8498 57.6312 13.3933 58.7948L45.8933 83.2948C47.1406 84.235 48.8598 84.235 50.1071 83.2948L82.6071 58.7948C84.1506 57.6312 84.4586 55.4366 83.295 53.8931C82.1314 52.3495 79.9369 52.0415 78.3933 53.2051L48.0002 76.1169L17.6071 53.2051Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5 40L48 15.5L80.5 40L48 64.5L15.5 40Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M50.1069 12.7052C48.8596 11.7649 47.1404 11.7649 45.8931 12.7052L13.3931 37.2052C12.5158 37.8665 12 38.9014 12 40C12 41.0986 12.5158 42.1335 13.3931 42.7948L45.8931 67.2948C47.1404 68.2351 48.8596 68.2351 50.1069 67.2948L82.6069 42.7948C83.4842 42.1335 84 41.0986 84 40C84 38.9014 83.4842 37.8665 82.6069 37.2052L50.1069 12.7052ZM48 60.1169L21.3143 40L48 19.8831L74.6857 40L48 60.1169Z" fill="#161617"/>
<path d="M17.6071 53.2051C16.0635 52.0415 13.869 52.3495 12.7054 53.8931C11.5418 55.4366 11.8498 57.6312 13.3933 58.7948L45.8933 83.2948C47.1406 84.235 48.8598 84.235 50.1071 83.2948L82.6071 58.7948C84.1506 57.6312 84.4586 55.4366 83.295 53.8931C82.1314 52.3495 79.9369 52.0415 78.3933 53.2051L48.0002 76.1169L17.6071 53.2051Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5 40L48 15.5L80.5 40L48 64.5L15.5 40Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
